import Vue from 'vue';

export const fetchOrdersQueue = async ({ session }) => {
  const response = await Vue.axios.get(`/get-orders-queue/${session}`);

  return response.data.data.orders_queue;
};
